import React from 'react'

const ContextIndicator = ({ hasBlocker, noteCount, hasReview, tasksOverdue }) => {
  if (!hasBlocker && !noteCount && !hasReview && !tasksOverdue) return null
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {hasBlocker && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--warn)', display: 'inline-block' }} />}
      {noteCount > 0 && <span style={{ fontSize: 10, color: 'var(--ink-3)' }}>{noteCount}</span>}
      {hasReview && <span style={{ fontSize: 9, padding: '1px 4px', borderRadius: 3, background: 'var(--info-tint, #e3f2fd)', color: 'var(--info)' }}>Review</span>}
      {tasksOverdue > 0 && <span style={{ fontSize: 10, color: 'var(--warn)', fontWeight: 600 }}>{tasksOverdue} overdue</span>}
    </span>
  )
}

export default ContextIndicator
